import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/PageHeader.js';

export function NotFoundPage(): ReactElement {
  return (
    <>
      <PageHeader title="Not found" description="There is nothing at that address." />
      <p>
        <Link className="button button--primary" to="/">
          Back to the overview
        </Link>
      </p>
    </>
  );
}
